import 'javascript/src/all_pages_head';
require("javascript/stylesheets/home.scss");
import srep from 'javascript/src/size_repartition.js';
import 'javascript/src/utils/promotion_slider.js';
import 'javascript/src/product/selections.js';
import 'javascript/src/product/vignettes_articles.js';
import 'javascript/src/product/promotions.js';
import "javascript/src/slide_basket";
import 'javascript/src/handle_fav_click';
